import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";


export interface DownloadAttachment {
  AuthNo: string,
  CompanyId: string,
  FileLocation: string,
  FileName: string,
}

export interface attachmentData {
  authNo: string;
  companyId: string;
  fileMeta: string;
  fileName: string;
  folderLocation: string;
  key: string;
}

export interface letterInfosData {
  fileDate: string;
  fileLocation: string;
  fileName: string;
  key: string;
}

export const getAttachInfo = (authNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ATTACH_INFO_REQUEST });

  return api.authorization.attach.getInfo(authNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ATTACH_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ATTACH_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const downloadAttachment = (model: DownloadAttachment) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
 
  dispatch({ type: types.DOWNLOAD_ATTACHMENT_REQUEST });

  return api.authorization.attach.download(model)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_ATTACHMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_ATTACHMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const isRequired = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_REQUIRED_REQUEST });

  return api.authorization.attach.isRequired()
    .then((res: any) => {

      dispatch({
        type: types.CHECK_REQUIRED_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_REQUIRED_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
